// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"e88be016","977":"1f97fba6"}[chunkId] + ".chunk.js";
};